export enum ReferenceCode {
  GeneralFailure = "RC320",
  AlloyUnderReview = "RC200",
  DocVUnderReview = "RC201",
  FiservEnrollmentFailure = "RC210",
  JointAccountEnrollmentFailure = "RC211",
  OnlineBankingEnrollmentFailure = "RC220",
  UnderReviewFailure = "RC230",
  AlloyDenied = "RC300",
  DocVDenied = "RC301",
  StatusUFailure = "RC310",
  EligibilityReviewFailure = "RC330",
  InternalFailure = "RC340",
  AlloyFailure = "RC350",
  DocVFailure = "RC351",
  SocureFailure = "RC360",
  EligibilityFailure = "RC370",
  EMailSSNCombinationInvalid = "RC380",
  ProductCheckFailure = "RC400",
  AccountRulesFailure = "RC401",
  HYSAAccountRulesFailure = "RC402",
  ApplicantInfoMismatch = "RC390",
  AlloyQualifileDecline = "RC303"
}
